import { Stack, TextField, IconButton, Typography } from "@mui/material";
import SaveIcon from "@mui/icons-material/Save";
import DeleteIcon from "@mui/icons-material/Delete";
import { useEffect, useState } from "react";
import { globalTheme } from "../../styles";
import React from "react";
import { CustomCellRendererProps } from "ag-grid-react";
import { useUpdateAction } from "../../hooks";
import { EditIcon } from "../Icon";
import { AUTHENTICATED_EMPLOYEE_JWT } from "../../constants";

interface OrderPrivateNotesProps extends CustomCellRendererProps {
  refreshData: () => void;
  setSnackBar: (snackBar: { open: boolean; message: string; severity: string }) => void;
}

export const OrderPrivateNotes = React.memo((params: OrderPrivateNotesProps) => {
  const { data, refreshData, setSnackBar, api } = params;
  const [privateNotes, setPrivateNotes] = useState<string>(data.internalNote || "");
  const [isEditable, setIsEditable] = useState<boolean>(false);

  const [actionUpdateRequest, setActionUpdateRequest] = useState({ request: [] });
  const [actionUpdateRequestEnable, setActionUpdateRequestEnable] = useState<boolean>(false);

  const prepareActionUpdateRequest = () => {
    return {
      actionType: "INTERNAL_NOTE",
      idList: data.orderIds,
      changes: [{ fieldName: "internalNote", oldValue: "", newValue: privateNotes }],
    };
  };

  const onSavePrivateNotes = () => {
    setActionUpdateRequestEnable(true);
    setActionUpdateRequest({ request: [prepareActionUpdateRequest()] });
  };

  const { successfullUpdatedAction, updateActionResponseData, errorFetchingActionUpdate } = useUpdateAction({
    updateActionRequest: actionUpdateRequest.request,
    enabled: actionUpdateRequestEnable,
  });

  useEffect(() => {
    if (updateActionResponseData?.code === "UNAUTHORIZED") {
      localStorage.removeItem(AUTHENTICATED_EMPLOYEE_JWT);
      window.location.reload();
    }
  }, [updateActionResponseData]);

  const handleNotesChange = (e) => {
    setPrivateNotes(e.target.value);
  };

  const handleEditClick = () => {
    setIsEditable(true);
  };

  const handleSaveClick = () => {
    onSavePrivateNotes();
    setIsEditable(false);
  };

  // const handleDeleteClick = () => {
  //   setPrivateNotes("");
  //   onSavePrivateNotes();
  // };

  useEffect(() => {
    if (updateActionResponseData) {
      onValidation();
    }
  }, [updateActionResponseData]);

  const onValidation = () => {
    if (updateActionResponseData.success === true) {
      setSnackBar({
        message: "Internal note updated successfully",
        severity: "success",
        open: true,
      });
      refreshData();
    } else {
      setSnackBar({
        message: updateActionResponseData.message,
        severity: "error",
        open: true,
      });
      setPrivateNotes(data.internalNote || "");
      refreshData();
    }
  };

  useEffect(() => {
    setActionUpdateRequestEnable(false);
  }, [actionUpdateRequestEnable]);

  return (
    <Stack spacing={2}>
      {data?.pickerNote && (
        <Stack direction="row" alignItems="center" spacing={1}>
          <Typography variant="caption">{`${data?.userId} Notes:`}</Typography>
          <Typography variant="caption" color={globalTheme.primaryColor}>
            {data?.pickerNote}
          </Typography>
        </Stack>
      )}
      <Stack direction="row" alignItems="center" spacing={1}>
        <label>Internal Notes</label>
        {isEditable ? (
          <IconButton onClick={handleSaveClick}>
            <SaveIcon sx={{ fill: globalTheme.primaryColor }} />
          </IconButton>
        ) : (
          <IconButton onClick={handleEditClick}>
            <EditIcon />
          </IconButton>
        )}
      </Stack>

      <TextField
        id="privateNotes"
        label=""
        placeholder="Add your notes here"
        multiline
        rows={4}
        variant="standard"
        value={privateNotes}
        onChange={handleNotesChange}
        disabled={!isEditable}
        sx={{
          backgroundColor: isEditable ? "white" : globalTheme.background,
          color: globalTheme.primaryColor,
          "& .MuiInputBase-input.Mui-disabled": {
            WebkitTextFillColor: globalTheme.primaryColor,
          },
        }}
      />
    </Stack>
  );
});
